module.exports = __webpack_public_path__ + "d07619e1bbc0af01c6f42213b44f9512.svg";